module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Tencent Interactive Live Streaming":"JIHONG Technology Live Streaming","roomId":"roomId","RoomId copied successfully":"RoomId copied successfully"},"zh":{"Tencent Interactive Live Streaming":"霁虹科技互动直播","roomId":"房间号","RoomId copied successfully":"房间ID复制成功！"}}')
  delete Component.options._Ctor
}
